import { apiClient } from "lib/apiClient";

export const transferCompProperty = async (
  compType: string,
  compId: string,
  propertyId: string
): Promise<void> => {
  await apiClient.post(`/comps/${compType}/${compId}/properties`, {
    propertyId,
  });
};
